import {createSelector} from "reselect";
import {getResellers} from "./SimpleSelectors";
import {agencyServerArticleNumber} from "../config/Config";

export const getAgencyServerResellers = createSelector(
    [getResellers],
    (resellers) => {

        const ret = Object.assign({}, resellers);

        Object.keys(resellers).forEach(key => {
            if ("" + resellers[key].articleNumber !== agencyServerArticleNumber) {
                delete ret[key];
            }
        })

        return ret;

    }
)



/** WEBPACK FOOTER **
 ** ./src/selectors/Resellers.js
 **/